import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { ClientesService } from "../../../services/clientes.service";
/*App imports*/
import { HelpersService, TiposCreditos } from '../../../services/tools/helpers.service';
import { CreditosService } from "../../../services/creditos.service";

@Component({
  selector: 'formulario-cliente',
  templateUrl: './formulario-cliente.component.html'
})
export class FormularioClienteComponent implements OnInit {

    @Input() public idClientes: number = null;
    @Input() public idCreditos: number = null;
    @Input() public isCompleted: boolean = false;
    @Input() public isEditable: boolean = false;
    @Output() public onClientUpdated:EventEmitter<string> = new EventEmitter;
    //Cliente form
    public cliente : any = {};
    public errors :any = {};
    public showClaveElector : boolean = false;
    public tiposPersonas: any[] = [];
    public isLoading: boolean = false;
    
    //Helpers
    private isInitialized : boolean = false;
    public tipoPersonaSelected: any = {};

    constructor(
      private clientesService : ClientesService,
      private helperService : HelpersService,
      private creditosService : CreditosService
    ){
      this.tiposPersonas = [{key:'FISICA', label: 'Física'}, {key:'MORAL', label: 'Moral'}];
    }

    public ngOnInit() {
    }

    public loadComponent(){
      if(!this.isInitialized){
        this.getCliente(this.idClientes);    
          this.isInitialized = true;
      }
    }

    private getCliente(idClientes){
      this.isLoading = true;
      this.clientesService.get(idClientes).subscribe(
        (response)=>
        {
          let cliente = response.json().content;
          this.cliente = cliente;
          this.selectTipoPersona(cliente.tipo_persona);
          this.isLoading = false;
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          
          if(error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
          this.isLoading = false;
        }
      );
    }

    public save(){
      this.errors = [];
      //En las validaciones el campo Clave de elector debe ser obligatorio
      this.errors = this.clientesService.validate(this.cliente);

      if (Object.entries(this.errors).length > 0) {
        return false;
      }

      this.clientesService.update(this.cliente).subscribe(
        (response)=>
        {
          const clientId = response.json().content;
          this.helperService.notification('Cliente actualizado', 'Se ha actualizado exitosamente la información del cliente ', 'success');
          this.onClientUpdated.emit();
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    public onSelectedTipoPersona(tipoPersona: any){
      this.tipoPersonaSelected = tipoPersona;
      this.cliente.tipo_persona = tipoPersona.key;
    }

    private selectTipoPersona(tipoPersona){
      let component = this;
      this.tiposPersonas.forEach(function(tipo) {
      
        if(tipo.key === tipoPersona){
          component.tipoPersonaSelected = tipo;
        }
      });
    }
  
    private setBackendErrors(errors:any[]){
      let temp_errors = [];
      
      Object.keys(errors).forEach(function(key){
        temp_errors[key] = errors[key][0];
      });
  
      this.errors = temp_errors;
    }
}



// WEBPACK FOOTER //
// ./src/app/creditos/components/formulario-cliente/formulario-cliente.component.ts